import { ORGANIZATION_NAME, SITE_URL } from './siteConfig';

export function buildOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: ORGANIZATION_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/images/myroomsai-logo.png`,
  };
}

export function buildSoftwareApplicationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: ORGANIZATION_NAME,
    applicationCategory: 'DesignApplication',
    operatingSystem: 'Web',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
    },
    url: SITE_URL,
    description:
      'MyRoomsAI is an AI-powered interior design web app that transforms real room photos into styled redesign concepts.',
  };
}

export function buildFaqSchema(faqs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };
}

export function buildBreadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}

export function buildWebPageSchema({ name, description, path }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name,
    description,
    url: `${SITE_URL}${path}`,
    isPartOf: {
      '@type': 'WebSite',
      name: ORGANIZATION_NAME,
      url: SITE_URL,
    },
  };
}

export function buildPublicToolPageSchemas(page) {
  if (!page) return [];

  const pageUrl = `${SITE_URL}${page.path}`;

  return [
    buildWebPageSchema({
      name: page.title,
      description: page.description,
      path: page.path,
    }),
    buildBreadcrumbSchema([
      { name: 'Home', path: '/' },
      { name: page.toolName || page.h1 || page.title, path: page.path },
    ]),
    {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name: page.toolName || page.h1 || page.title,
      applicationCategory: 'DesignApplication',
      operatingSystem: 'Web',
      url: pageUrl,
      description: page.description,
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'USD',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: page.featuresTitle,
      description: page.description,
      url: pageUrl,
      itemListElement: (page.features || []).map((feature, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: feature,
        url: pageUrl,
      })),
    },
  ];
}

export function buildItemListSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Real Room Transformations',
    description: 'Before and after AI room redesign examples from real user photos.',
    url: `${SITE_URL}/real-transformations`,
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: `${item.roomType} – ${item.style}`,
      description: item.description,
      url: `${SITE_URL}/real-transformations`,
    })),
  };
}

export function buildBlogPostingSchema({ title, description, publishDate, author, path }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: title,
    description,
    author: {
      '@type': 'Organization',
      name: author || ORGANIZATION_NAME,
    },
    publisher: {
      '@type': 'Organization',
      name: ORGANIZATION_NAME,
      logo: {
        '@type': 'ImageObject',
        url: `${SITE_URL}/images/myroomsai-logo.png`,
      },
    },
    datePublished: publishDate,
    url: `${SITE_URL}${path}`,
    mainEntityOfPage: `${SITE_URL}${path}`,
  };
}
